var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"9","height":"5","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.5 5L9 0H0z","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }